import { resizeImage, setAutoFormat } from '@micromart/utils/lib/cloudinary'

export const responsiveImageProps = {
	width: '100%',
	height: '100% !important',
	objectFit: 'cover',
	aspectRatio: '1 / 1',
	borderRadius: 1,
}

export const emptyResponsiveImageProps = {
	sx: {
		...responsiveImageProps,
		alignItems: 'center',
		justifyContent: 'center',
		bgcolor: 'var(--mui-palette-background-level2)',
		display: 'flex',
	},
}

export const getResponsiveImageProps = (photo: string, size = 550) => {
	const url = resizeImage(photo, size * 2, size * 2)

	return {
		sx: {
			...responsiveImageProps,
			backgroundImage: `url(${url})`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
		},
	}
}

/** Small list/chip thumbnail — Cloudinary pad + 2× pixel density for crisp display. */
export function chipThumbnailUrl(photo: string, displayPx = 18): string {
	return setAutoFormat(resizeImage(photo, displayPx * 2, displayPx * 2, true))
}
